import BaseModel from './BaseModel';

export default class ExportDownloadDto extends BaseModel {
  constructor(data = {}) {
    super(ExportDownloadDto, data);
    this.signedDownloadUrl = data.signedDownloadUrl;
    this.expiryInMinutes = data.expiryInMinutes;
  }
}
